import payGroup from './payGroup/payGroup.js';
import headCount from './headCount.js';
import employeeProfile from './employeeProfile.js';
import lockPayroll from './lockPayroll.js';
export default {
    namespaced: true,
    modules: {
        payGroup: payGroup,
        headCount: headCount,
        employeeProfile: employeeProfile,
        lockPayroll: lockPayroll
    }
};
